import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import Spinner from '../../../components/common/Spinner';
import {
  Flex,
  FlexCenter,
  FlexJustifyCenter
} from '../../../styles/stylesStyled';
import { AmountBox, Info, ShowButton, Subtitle, Title } from './WithdrawStyled';

import { useTranslation } from 'react-i18next';
import { Desktop } from '../../../App';
import { useAppSelector } from '../../../app/hooks';
import { CheckText } from '../../../components/common/CheckText';
import { formatUSD, showWallet, USDT } from '../../../helpers/helperFunctions';
import { P1, P3 } from '../../../styles/FontStyles';
import { Button, CircleIconWrapper } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWithdrawAlert } from '../../../styles/Icons';

interface WithdrawFinalCheckProps {
  setStep: Dispatch<SetStateAction<number>>;
  amount: string;
  selected: number;
  selectedWallet: any;
  selectedNetwork: any;
  selectedToken: any;
}

export const WithdrawFinalCheck = ({
  setStep,
  amount,
  selected,
  selectedWallet,
  selectedNetwork,
  selectedToken
}: WithdrawFinalCheckProps) => {
  const { t } = useTranslation('earnings');
  const [checkbox, setCheckbox] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const fee = 5;
  const [total, setTotal] = useState(0);

  const { loading } = useAppSelector((state) => state.withdraw);

  const { verificationStatus } = useAppSelector((state) => state.settings);

  const selectedNetworkType = (type: number) => {
    switch (type) {
      case 1:
        return 'BEP20.';

      case 2:
        return 'TRC20.';

      case 3:
        return 'ULC-20.';

      default:
        return '';
    }
  };

  useEffect(() => {
    setTotal(Number(amount) - Number(fee));
  }, [amount, total]);

  return (
    <div>
      <>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Title>{t('withdraw_part.final_check.title')}</Title>
            <Subtitle>
              <Subtitle style={{ textAlign: 'center' }}>
                Please make sure that the wallet you are adding is capable of
                receiving USDT/USDC on BEP-20.
              </Subtitle>
              {/* <P3 center bold mt='10'>
                PLEASE MAKE SURE THAT THE WALLET YOU ARE ADDING IS CAPABLE OF
                RECEIVING {selectedToken?.token} ON{' '}
                {selectedNetworkType(selectedNetwork?.networkType)}
              </P3> */}
            </Subtitle>
            <AmountBox>
              <Info>
                <div>{t('withdraw_part.final_check.amount')}:</div>
                {amount} {selectedToken?.token}
              </Info>
              <Info style={{ wordBreak: 'break-all' }}>
                <div>{t('withdraw_part.final_check.network')}:</div>{' '}
                {selectedNetwork?.wallet}
              </Info>
              <Info style={{ wordBreak: 'break-all' }}>
                <div>{t('withdraw_part.final_check.address')}:</div>{' '}
                {showMore && selectedWallet.address}
                {!showMore && showWallet(selectedWallet.address, -9)}
                <Desktop>
                  {!showMore && (
                    <ShowButton onClick={() => setShowMore(true)}>
                      Show
                    </ShowButton>
                  )}
                </Desktop>
              </Info>
              <Info>
                <div>{t('withdraw_part.final_check.processing_fee')}:</div>{' '}
                {fee} {selectedToken?.token}
              </Info>
            </AmountBox>

            <Flex>
              <P1 bold mt='20' mb='20'>
                Total:
              </P1>

              <P1 bold ml='10' mt='20' mb='20'>
                {formatUSD(total)} {selectedToken?.token}
              </P1>
            </Flex>

            <P3 bold color={'#858585'} mb='16'>
              If payment wallet address is incorrect the transaction cannot be
              refunded. Please verify the wallet address is correct before
              confirming the transaction!
            </P3>

            <CheckText
              checked={checkbox}
              checkColor={color.colors.primary900}
              onClick={() => setCheckbox(!checkbox)}
              text={t('withdraw_part.final_check.confirm_txt')}
            />

            <FlexCenter style={{ flexDirection: 'column' }}>
              <Button
                maxWidth='200px'
                m={'30px 0 0 0'}
                opacity={'true'}
                disabled={!checkbox}
                onClick={() => {
                  if (!verificationStatus) {
                    setStep(8);
                  } else {
                    setStep(6);
                  }
                  // if (!verificationStatus) {
                  //   setStep(8);
                  // } else {
                  //   if (userWallets[selected].isFlipme) {

                  //   } else {
                  //     setStep(6);
                  //   }
                  // }
                }}>
                Withdraw Funds
              </Button>
            </FlexCenter>
          </>
        )}
      </>
    </div>
  );
};
